export const subtitles = {
    "1": {
        "startTime": 7.18,
        "endTime": 13.32,
        "transcript": "Iciw' maa-i irniat ilait cayunqeggiatetuut, ilait-llu cayunqeggluteng.",
        "translation": "You know, some of these children don't like doing things, and some do."
    },
    "2": {
        "startTime": 17.965,
        "endTime": 19.285,
        "transcript": "Ila-i.",
        "translation": "Oh my goodness."
    },
    "3": {
        "startTime": 19.29,
        "endTime": 22.17,
        "transcript": "Wiinga tau͡gaam [?] pikuma-wa.",
        "translation": "I should be on [?]."
    },
    "4": {
        "startTime": 23.465,
        "endTime": 25.405,
        "transcript": "Yaa. (Good.) Ii-i.",
        "translation": "Yes. (Good.) Yes."
    },
    "5": {
        "startTime": 25.405,
        "endTime": 27.505,
        "transcript": "Atam-qaa aptelarniarpenga?",
        "translation": "Will you ask me questions?"
    },
    "6": {
        "startTime": 30.11,
        "endTime": 30.83,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "7": {
        "startTime": 32.035,
        "endTime": 39.755,
        "transcript": "Qanqall'eryugngaunga-llu Kass'atun elitnaulqa carraungraan Kass'ani uitalallruama.",
        "translation": "I can also speak some English even though I didn't go to school for long since I used to stay with Caucasians."
    },
    "8": {
        "startTime": 41.01,
        "endTime": 42.54,
        "transcript": "Nani Kass'ani?",
        "translation": "Where with Caucasians?"
    },
    "9": {
        "startTime": 42.54,
        "endTime": 45.51,
        "transcript": "Cakayiinkuni, John Samuelson.",
        "translation": "With Cakayak and family, John Samuelson."
    },
    "10": {
        "startTime": 46.1,
        "endTime": 47.62,
        "transcript": "Qanrutkeciqaqa.",
        "translation": "I'll talk about it."
    },
    "11": {
        "startTime": 48.675,
        "endTime": 50.605,
        "transcript": "Kass'at Nunapicuarni. (Taukuni-qaa anglillruuten?)",
        "translation": "The Caucasians in Nunapitchuk. (Did you grow up with them?)"
    },
    "12": {
        "startTime": 50.605,
        "endTime": 54.22,
        "transcript": "Nuu, part, iliini tau͡gaam.",
        "translation": "No, part[ly], only sometimes."
    },
    "13": {
        "startTime": 54.22,
        "endTime": 56.49,
        "transcript": "Nani? Nunapicuarmi-qaa Samuelson-aankut?",
        "translation": "Where? Was the Samuelson family at Nunapitchuk?"
    },
    "14": {
        "startTime": 56.49,
        "endTime": 58.27,
        "transcript": "Yaa, uitatullruut.",
        "translation": "Yes, they lived there."
    },
    "15": {
        "startTime": 58.275,
        "endTime": 65.545,
        "transcript": "Nunacuarmek move-arluteng Nunapicuarmun. Tuani Cakayak kiputellruuq.",
        "translation": "They moved from Nunacuar to Nunapitchuk. There, Cakayak traded."
    },
    "16": {
        "startTime": 67.805,
        "endTime": 69.885,
        "transcript": "Tauna-qaa kiputeqarraarluku?",
        "translation": "After he bought that?"
    },
    "17": {
        "startTime": 71.77,
        "endTime": 75.08,
        "transcript": "Kiputesteńgullruuq cakenpak.",
        "translation": "He was a prolific trader."
    },
    "18": {
        "startTime": 75.08,
        "endTime": 78.63,
        "transcript": "Apqiitnek-llu kupcaari amllepiarluteng.",
        "translation": "And he had very many of what they called his merchants."
    },
    "19": {
        "startTime": 78.63,
        "endTime": 82.15,
        "transcript": "Tuani tua-i kipusvingqellruuq Nunapicuarmi.",
        "translation": "He had a trading post there in Nunapitchuk."
    },
    "20": {
        "startTime": 82.825,
        "endTime": 86.975,
        "transcript": "Nunacuarmiut ancatni. Ancitullruut nunat.",
        "translation": "[That was] when Nunacuarmiut exiled him. Villages used to exile people."
    },
    "21": {
        "startTime": 87.105,
        "endTime": 89.615,
        "transcript": "Nunapicuarnun-llu piluni.",
        "translation": "And he went to Nunapitchuk."
    },
    "22": {
        "startTime": 89.895,
        "endTime": 98.085,
        "transcript": "Iciw' ancituut. Ancitullilriit-wa cali maa-i, Kass'at apqiitnek kick out-arluki.",
        "translation": "You know, they exiled people. They probably still exile now, kicking them out as they say in English."
    },
    "23": {
        "startTime": 98.135,
        "endTime": 103.425,
        "transcript": "Tuaten pimallruuq Cakayak Nunacuarmek Nunapicuarmun.",
        "translation": "That's what happened to Cakayak from Nunacuar to Nunapitchuk."
    },
    "24": {
        "startTime": 106.095,
        "endTime": 109.885,
        "transcript": "Maa-i-w' allaullilria. Imumi-w' tua-i tuaten.",
        "translation": "It's probably different now. It was like that back then."
    },
    "25": {
        "startTime": 109.885,
        "endTime": 111.475,
        "transcript": "Ciin-gguq antellruatgu?",
        "translation": "Why did they exile him?"
    },
    "26": {
        "startTime": 111.505,
        "endTime": 116.125,
        "transcript": "Picingssaungan-wa amllernek irniiriang anteskiit.",
        "translation": "They exiled him because he would fool around and had many children."
    },
    "27": {
        "startTime": 117.95,
        "endTime": 119.72,
        "transcript": "Tamana qanrutek'laaggu.",
        "translation": "Speak briefly on that."
    },
    "28": {
        "startTime": 120.43,
        "endTime": 123.08,
        "transcript": "Qanrutekngaitaqa.",
        "translation": "I won't talk about it."
    },
    "29": {
        "startTime": 124.4,
        "endTime": 126.73,
        "transcript": "Assirtuq Cakayak.",
        "translation": "Cakayak was good."
    },
    "30": {
        "startTime": 128.63,
        "endTime": 132.22,
        "transcript": "Ilumun irnillruuq amllernek, irniirillruuq amllernek.",
        "translation": "Indeed, he bore many children, he sired many children."
    },
    "31": {
        "startTime": 133.14,
        "endTime": 135.34,
        "transcript": "Taumek aneskiit.",
        "translation": "That's why they exiled him."
    },
    "32": {
        "startTime": 135.345,
        "endTime": 138.515,
        "transcript": "Assilriit yuut nunat ancuitait.",
        "translation": "Villages don't exile good people."
    },
    "33": {
        "startTime": 138.515,
        "endTime": 144.085,
        "transcript": "Tau͡gaam when they do something wrong.",
        "translation": "Only when they do something wrong."
    },
    "34": {
        "startTime": 144.405,
        "endTime": 157.555,
        "transcript": "Kitak' ak'a nasaurluullraullerpenek tamaaken umyuaqellerpetun qanrutkeqerru.",
        "translation": "Now, please speak about things you remember back when you were a little girl as you remember it."
    },
    "35": {
        "startTime": 158.495,
        "endTime": 168.39,
        "transcript": "Tua-i-w' ava-i qanelrianga avani Nelson Island-aami yuurtellruyaaqua, tau͡gaam nani yuurtelqa waniw' nalluamku.",
        "translation": "I just said that I was born over on Nelson Island, but I don't know [exactly] where I was born."
    },
    "36": {
        "startTime": 168.39,
        "endTime": 175.82,
        "transcript": "Tua-i-llu waten ayalalliniameng iciw' move-arluteng, nunalinqiggluteng",
        "translation": "Then because they travel like this, you know, move, nunalinqiggluteng"
    },
    "37": {
        "startTime": 175.82,
        "endTime": 180.74,
        "transcript": "Angayuqaagka-am taukuk taillinilutek maavet Kusquqvagmun.",
        "translation": "My parents apparently came here to the Kuskokwim."
    },
    "38": {
        "startTime": 181.665,
        "endTime": 183.78,
        "transcript": "Qaill' piamek piak.",
        "translation": "I'm not sure why they did."
    },
    "39": {
        "startTime": 183.78,
        "endTime": 195.94,
        "transcript": "Tua-i-ll' Oscarville-ami Kuiggayagarmi anngarput Cakayiim atallran Oscar Samuelson-aam pistekluku.",
        "translation": "Then in Oscarville, Kuiggayagaq, our older brother was Cakayak's late father's, Oscar Samuelson, helper."
    },
    "40": {
        "startTime": 195.945,
        "endTime": 203.06,
        "transcript": "Aanaput-llu neqlisteńguluni taumi Oscar Samuelson, Cakayiim atallrani.",
        "translation": "And our mother would work on fish there with Oscar Samuelson, Cakayak's late father."
    },
    "41": {
        "startTime": 203.06,
        "endTime": 210.82,
        "transcript": "Tua-i-ll' tuanlluta kiagpak. Uksuaran-llu Akulmun tagluta Kassiglumun.",
        "translation": "Then we were there all summer. And when fall set, we went up to Kasigluk in the Akula region."
    },
    "42": {
        "startTime": 211.115,
        "endTime": 219.625,
        "transcript": "Tuanlluta tua-i. Tua-i tang tua-i tuani Kassigluni how many years-kiq uitallruceta?",
        "translation": "We were there. You see, I wonder how many years we stayed there in Kasigluk?"
    },
    "43": {
        "startTime": 219.625,
        "endTime": 230.935,
        "transcript": "Imkut yuut caceskitellrulliniameng, tua-i-am elitnaullerkarput pitekluku angayuqaagka imkuk... caceskit'urlulliniut imkut yuut.",
        "translation": "Because people were apparently fickle, for our eduction, my parents... those poor people were apparently fickle."
    },
    "44": {
        "startTime": 230.935,
        "endTime": 241.225,
        "transcript": "Nunapicuarmun-am move-aqilta, cunaw' elitnauristengqataata. Egmian elitnaurvingellrunritut.",
        "translation": "We moved to Nunapitchuk, it turned out because they were going to get a teacher. They didn't get a school right away."
    },
    "45": {
        "startTime": 241.225,
        "endTime": 248.63,
        "transcript": "Qaillun tamaani wani elpeci angayuqaci elitnauq umyuaqekutelallruatgu?",
        "translation": "Back then, what did your parents think of going to school?"
    },
    "46": {
        "startTime": 248.63,
        "endTime": 254.62,
        "transcript": "Cingumallruiceci-qaa elpeci irniamteńi Kass'atun elitnauresqelluci?",
        "translation": "Did they support their children having a Western education?"
    },
    "47": {
        "startTime": 254.62,
        "endTime": 258.26,
        "transcript": "Qaillun niitelallerpenek tamana cali qanrutkeqerru.",
        "translation": "Please talk about what you heard about that."
    },
    "48": {
        "startTime": 258.745,
        "endTime": 261.075,
        "transcript": "Qaillun niitelalqa nalluaqa.",
        "translation": "I don't know what I heard."
    },
    "49": {
        "startTime": 261.075,
        "endTime": 271.465,
        "transcript": "Tua-i taukuk angayuqaagka cingumalliamegtekut elitnaullerkamteńun Nunapicuarmun move-autellruitkut Kassiglumek.",
        "translation": "Because my parents probably supported our education, they moved us from Nunapitchuk to Kasigluk."
    },
    "50": {
        "startTime": 271.605,
        "endTime": 277.175,
        "transcript": "Nanvarnarrlagmi-ll' cali nunartangqellruut Nunapicuarmiut avalirneratni.",
        "translation": "There was also a village in Nanvarnarrlak over from Nunapitchuk."
    },
    "51": {
        "startTime": 277.175,
        "endTime": 283.31,
        "transcript": "Tua-i-llu elitnau... nuu, elitnaurvingellratni taukut move-allruut Nunapicuarmun.",
        "translation": "Then the school... no, when a school was built, they moved to Nunapitchuk."
    },
    "52": {
        "startTime": 283.31,
        "endTime": 293.0,
        "transcript": "Tuani ima tang wangkuta move-aqainallemteńi elitnauristet enemetellrulriit. Elitnaurvigtaunani.",
        "translation": "Just when we moved there, the teachers were in houses. There was no school."
    },
    "53": {
        "startTime": 293.0,
        "endTime": 299.15,
        "transcript": "Agayuvillermi-ll' pia-i agayuvigmi elitnauraqluta. Kianlluni kiaqlimteńi.",
        "translation": "And we'd have school in the old church inland. It was upriver, upriver from us."
    },
    "54": {
        "startTime": 300.31,
        "endTime": 307.97,
        "transcript": "Tau͡gaam how many years-kiq? Tuar tang two years agayuvigmi elitnaulriakut wall'u-qaa one year.",
        "translation": "But I wonder how many years? It seems that we went to school in the church for two years or one year."
    },
    "55": {
        "startTime": 307.975,
        "endTime": 320.495,
        "transcript": "Tua-i-llu pia-i old school-aq tauna tang piurtellrani Number Two-rmiut pia-i Nanvarnarrlagmiut move-allrungatellinilriit Nunapicuarmun.",
        "translation": "Then when that old school inland was built, the ones in Number Two from Nanvarnarrlak inland moved to Nunapitchuk."
    },
    "56": {
        "startTime": 320.69,
        "endTime": 326.09,
        "transcript": "Nunarpallrauluteng, Number One, Number Two, tuaten-llu aterluteng.",
        "translation": "It was a big village, Number One, Number Two, and they had those names."
    },
    "57": {
        "startTime": 326.195,
        "endTime": 332.085,
        "transcript": "Cingumalliamegteki-w' move-alriit-llu taukut nunat Nunapicuarmun.",
        "translation": "Probably because they were supportive, those villages also moved to Nunapitchuk."
    },
    "58": {
        "startTime": 333.015,
        "endTime": 334.525,
        "transcript": "Tuaten.",
        "translation": "Like that."
    },
    "59": {
        "startTime": 334.525,
        "endTime": 343.755,
        "transcript": "Maa-i cali makut-wa ciulirneret tayima-ll' un'gani pitalguteten waten qanlartut:",
        "translation": "Now, these elders, and probably your peers, say this:"
    },
    "60": {
        "startTime": 343.766,
        "endTime": 353.016,
        "transcript": "Elitnaullermeggni, elitnaullermeggni tamaani elitnauristaita-llu Kass'atun, aren nuu, Yugtun qanresqeksaunaki.",
        "translation": "When they went to school back then, their teachers would tell them not to speak English, I mean no, in Yup'ik."
    },
    "61": {
        "startTime": 353.02,
        "endTime": 356.762,
        "transcript": "Cakneq murilkaqluki. Qaill' elpeci pilallruceci?",
        "translation": "They were very strict. What did you do?"
    },
    "62": {
        "startTime": 356.769,
        "endTime": 358.019,
        "transcript": "Tuaten.",
        "translation": "Like that."
    },
    "63": {
        "startTime": 358.217,
        "endTime": 368.317,
        "transcript": "Qanelria-ll' una punish-araqluku corner-aamun nangertelluku, corner-aaq cauluku how many minutes.",
        "translation": "And they'd punish one who spoke [Yup'ik] by sending them to the corner, and they'd face the corner for several minutes."
    },
    "64": {
        "startTime": 368.547,
        "endTime": 370.413,
        "transcript": "Tuaten pitullruitkut.",
        "translation": "That's what they did to us."
    },
    "65": {
        "startTime": 370.418,
        "endTime": 374.426,
        "transcript": "Tua-llu cali nerevkarpek'nata, no lunch.",
        "translation": "Then they also wouldn't let us eat, no lunch."
    },
    "66": {
        "startTime": 374.435,
        "endTime": 376.493,
        "transcript": "Nertullruut-qaa?",
        "translation": "Would they eat?"
    },
    "67": {
        "startTime": 376.625,
        "endTime": 381.091,
        "transcript": "Tua-i-w' tamaa-i anucimirqecetaaralallrukaitkut.",
        "translation": "That's how they would chastise us."
    },
    "68": {
        "startTime": 381.094,
        "endTime": 384.969,
        "transcript": "Cali-llu tuar niitelallrulrianga, tau͡gaam wii tangeqsaitua.",
        "translation": "And it seems I also heard, but I never saw."
    },
    "69": {
        "startTime": 384.982,
        "endTime": 390.998,
        "transcript": "Piqertualallruit-gguq canek imkunek. Iciw' spank.",
        "translation": "They said they would be spank them with those things. You know, spank."
    },
    "70": {
        "startTime": 391.745,
        "endTime": 393.728,
        "transcript": "Wii nalluanka.",
        "translation": "I don't know about them."
    },
    "71": {
        "startTime": 396.714,
        "endTime": 409.275,
        "transcript": "Maa-i-mi wangkuta elitnaulput, elitnaulput-wa cumikenrungataput elpeni elitnaullerpet nalliini.",
        "translation": "Now, it seems that we are more focused on school than when you went to school."
    },
    "72": {
        "startTime": 410.133,
        "endTime": 412.177,
        "transcript": "Maa-i-qaa? Ii-i.",
        "translation": "Now? Yes."
    },
    "73": {
        "startTime": 412.563,
        "endTime": 420.374,
        "transcript": "Cumikelliamegteggu-wa elitnaurturalalriit.",
        "translation": "They go to school for a long time probably because they focus on it."
    },
    "74": {
        "startTime": 420.387,
        "endTime": 425.198,
        "transcript": "Wangkuta-llu-wam tuani elitnauristengqarraallruamta Yugmek.",
        "translation": "Our first teacher then was also Yup'ik."
    },
    "75": {
        "startTime": 425.468,
        "endTime": 429.846,
        "transcript": "Iciw' [?Anrok], Sam [?Anrok]. Tauna.",
        "translation": "You know, [?Anrok], Sam [?Anrok]. That one."
    },
    "76": {
        "startTime": 429.866,
        "endTime": 434.988,
        "transcript": "Paniminek aiparluni Ruth Hall. Ruth Hall-aurtellruuq yaa-i.",
        "translation": "[S]he was accompanied with their daughter, Ruth Hall. She became Ruth Hall over there."
    },
    "77": {
        "startTime": 434.99,
        "endTime": 443.402,
        "transcript": "Taukuk tua-i ciumek elitnauristeńgurtellruuk Nunapicuarmi. Ciuqlikacagaulutek panikellriik.",
        "translation": "They were the first to become teachers in Nunapitchuk. The very first ones, parent and daughter."
    },
    "78": {
        "startTime": 443.416,
        "endTime": 446.56,
        "transcript": "Ungalaqlirnek cunaw' tailutek.",
        "translation": "Apparently, they came from Unalakleet."
    },
    "79": {
        "startTime": 446.968,
        "endTime": 448.757,
        "transcript": "Tua-i tuaten.",
        "translation": "Like that."
    },
    "80": {
        "startTime": 449.284,
        "endTime": 455.817,
        "transcript": "Tuaten-wa tua-i anucimirqecetaarucillruut.",
        "translation": "That's how they would chastise them."
    },
    "81": {
        "startTime": 455.904,
        "endTime": 459.46,
        "transcript": "Iqmigngaunateng-llu elitnaurvigmi.",
        "translation": "And they wouldn't chew tobacco in  school."
    },
    "82": {
        "startTime": 462.533,
        "endTime": 467.866,
        "transcript": "Ava-i ayagnirpailemnuk qanellruuten niicuilkengarpenek qanqatarniluten.",
        "translation": "Before we started just now, you said you were going to say something you never heard of."
    },
    "83": {
        "startTime": 467.877,
        "endTime": 471.321,
        "transcript": "Ii-i, waniwa-w' tekiteksailkevvuk.",
        "translation": "Yes, we haven't gotten to that yet."
    },
    "84": {
        "startTime": 471.323,
        "endTime": 475.768,
        "transcript": "Kitak' waniwa (Ii-i.) qanrutkeqerru. (Ii-i.)",
        "translation": "So now, (Okay.) please talk about it. (Okay.)"
    },
    "85": {
        "startTime": 476.753,
        "endTime": 481.875,
        "transcript": "Wiinga wani... waniwa-q' teguqcaarararpecia? Yaa.",
        "translation": "I... are you recording me now? Okay."
    },
    "86": {
        "startTime": 482.326,
        "endTime": 483.682,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "87": {
        "startTime": 483.78,
        "endTime": 492.947,
        "transcript": "Mat'um nalliini wii tukuurtessiyaagata yuut, iciw' tukuurcamta qaneryugtua.",
        "translation": "Because people are too wealthy tehse days, you know, since we're now wealthy, I want to say something."
    },
    "88": {
        "startTime": 492.961,
        "endTime": 496.016,
        "transcript": "Wangkuta arrsaullruukut.",
        "translation": "We were poor."
    },
    "89": {
        "startTime": 496.031,
        "endTime": 499.164,
        "transcript": "Wiinga-ll' arrsaullruunga angayuqaagka...",
        "translation": "I was also poor with my parents..."
    },
    "90": {
        "startTime": 499.172,
        "endTime": 507.405,
        "transcript": "Amta-ll' wangkuta angniraqluta, ner'aqluta, tua-i happy.",
        "translation": "And yet we were happy, we'd eat, just happy."
    },
    "91": {
        "startTime": 507.662,
        "endTime": 509.84,
        "transcript": "Tau͡gken tuaten ayuqluta.",
        "translation": "Yet we were [poor] like that."
    },
    "92": {
        "startTime": 509.851,
        "endTime": 513.384,
        "transcript": "Enemta iluit cataunateng.",
        "translation": "There was nothing in our houses."
    },
    "93": {
        "startTime": 514.247,
        "endTime": 520.436,
        "transcript": "Kankuk tau͡gaam yaassiiggaak... qulqitnek-llu tang waniw' tangeqsaitellrulrianga.",
        "translation": "Only two small boxes down there... and, you see, I didn't see any shelves."
    },
    "94": {
        "startTime": 520.449,
        "endTime": 522.727,
        "transcript": "Yaassiiggaak kanani pinaurtuk.",
        "translation": "There'd be two small boxes down there."
    },
    "95": {
        "startTime": 522.741,
        "endTime": 532.73,
        "transcript": "Ikirrlukek tang aanaput yuurqaqatalliniaqameng saskanek ancinaurtuq, tua-i-ll' qaingagni yuurqerluta.",
        "translation": "You see, my mother would open them when they were going to have hot drinks and take out cups, then we'd have hot drinks on top of them."
    },
    "96": {
        "startTime": 533.818,
        "endTime": 538.029,
        "transcript": "Tuar-llu tang eruriyuilngukut. Naamell'.",
        "translation": "And it seemed we wouldn't was dishes. I don't know."
    },
    "97": {
        "startTime": 538.033,
        "endTime": 542.378,
        "transcript": "Tua-i wii ceńirtaalgullruama tang qaunqessiyaallrunrilkenka.",
        "translation": "Since I'd always visit others, you see, I didn't take care of them too much."
    },
    "98": {
        "startTime": 546.786,
        "endTime": 551.719,
        "transcript": "Tua-i-llu maa-i mat'um nalliini anagutut people.",
        "translation": "Then these days, people are excessive."
    },
    "99": {
        "startTime": 551.884,
        "endTime": 555.495,
        "transcript": "Yugtun... Kass'atun-qaa mumigciiqaten qanellrenka?",
        "translation": "In Yup'ik... will you translate what I say into English?"
    },
    "100": {
        "startTime": 556.451,
        "endTime": 567.674,
        "transcript": "Arcaqerluk' tang ayagyuanun niitesqumayaaqekeka tau͡gaam qitevquraqtalaameng Yugtun-llu qanyuunateng amlleq taringengaitaat.",
        "translation": "You see, I especially want the youth to hear this, but because they always speak English and don't speak Yup'ik, they won't understand a lot."
    },
    "101": {
        "startTime": 568.8,
        "endTime": 572.978,
        "transcript": "Ilii-w' Kass'atum piqaqulaqumku canritlilria.",
        "translation": "It's probably fine if I periodically do some of it in English."
    },
    "102": {
        "startTime": 573.753,
        "endTime": 578.775,
        "transcript": "Mat'um nalliini anagutpiarluteng eneput.",
        "translation": "These days, our houses are very excessive."
    },
    "103": {
        "startTime": 578.781,
        "endTime": 581.403,
        "transcript": "We're rich right now.",
        "translation": "We're rich right now."
    },
    "104": {
        "startTime": 581.948,
        "endTime": 584.67,
        "transcript": "We have everything in the house.",
        "translation": "We have everything in the house."
    },
    "105": {
        "startTime": 585.252,
        "endTime": 591.83,
        "transcript": "Ca tamalkuan avaliqluku. Tuar wangkuta Kass'at, Yuuluta tau͡gaam.",
        "translation": "We have everything. It seems we're Westers, yet we're Yup'ik."
    },
    "106": {
        "startTime": 592.735,
        "endTime": 607.791,
        "transcript": "Tua-i-llu wiinga taukuni Cakayiinkuni Johnny Samuelson-aaq trading post-arluni Nunapicuarmi uitavallutullruunga nasaurluulua.",
        "translation": "Then I mostly stayed there with Cakayak and family as a girl, where Johnny Samuelson had a trading post in Nunapitchuk."
    },
    "107": {
        "startTime": 607.999,
        "endTime": 615.443,
        "transcript": "Nulirra tang una cassiyaayuunani, iciw' tua-i mulngaku'urngataqluni.",
        "translation": "You see, his wife wouldn't do much, you know, seeming to always be careful."
    },
    "108": {
        "startTime": 615.45,
        "endTime": 624.505,
        "transcript": "Wiinga tang eruringuarturnaurtua. Agleqsaunii-llu maybe 10 years old, or nine, tamaani.",
        "translation": "You see, I would always was dishes. And I didn't have my first menstruations [at] maybe 10 years old, or nine, at that time."
    },
    "109": {
        "startTime": 626.003,
        "endTime": 631.826,
        "transcript": "Cat-llu makut perrirturaraqluki pisqelaaki taum nulirran.",
        "translation": "And I'd always wipe [dust] off of things because his wife would tell me to."
    },
    "110": {
        "startTime": 632.325,
        "endTime": 635.425,
        "transcript": "Cunaw' Kassaungamek.",
        "translation": "Apparently, because they were Caucasian."
    },
    "111": {
        "startTime": 635.441,
        "endTime": 640.841,
        "transcript": "Tua-i half breed, avguami uinga. Nulirra-w' caullrua.",
        "translation": "Well, half breed, since her husband was half. I'm not sure what his wife was."
    },
    "112": {
        "startTime": 640.849,
        "endTime": 642.638,
        "transcript": "Tuaten wii anglilua.",
        "translation": "I grew up like that."
    },
    "113": {
        "startTime": 642.653,
        "endTime": 650.342,
        "transcript": "Utertaqama-llu uitarrlainanrilama ilamnun-am family-mnun utertaqama",
        "translation": "And when I went home, since I didn't always stay with my family, when I went home"
    },
    "114": {
        "startTime": 650.349,
        "endTime": 655.26,
        "transcript": "Imkuni Kass'ani pilalqa ayuqeliluku enemteńi.",
        "translation": "I would do the same in our house as I did at the Caucasians'."
    },
    "115": {
        "startTime": 655.268,
        "endTime": 661.457,
        "transcript": "Cat makut kitukcaarnaunka. Cunaw' dust out-alallrullinikenka-ll' cat.",
        "translation": "I would fix these things. Apparently, I'd also dust things out."
    },
    "116": {
        "startTime": 661.472,
        "endTime": 665.194,
        "transcript": "Assircaarturluki pinaunka tang.",
        "translation": "You see, I'd do them well."
    },
    "117": {
        "startTime": 665.21,
        "endTime": 668.21,
        "transcript": "Tua-i taukugnek elillua.",
        "translation": "I learned from them."
    },
    "118": {
        "startTime": 668.218,
        "endTime": 677.196,
        "transcript": "Mat'um nalliini high school, college pitanguq.",
        "translation": "These days, there is high school, [and] college."
    },
    "119": {
        "startTime": 677.201,
        "endTime": 688.146,
        "transcript": "Umyuarteq'lartua, \"Makuskiq maa-i nallunritpiarpagtut, qaillun-llu enem iluan clean up-aallerkaanek.\"",
        "translation": "I think, \"These people absolutely know things, including how to clean up inside the house.\""
    },
    "120": {
        "startTime": 689.187,
        "endTime": 698.287,
        "transcript": "Tuaten umyuarteq'lartua. Tuaten wii ayuqelqa Kass'ani uitaqtaqalqa pitekluku elitellruunga tamatumek.",
        "translation": "That's what I think. Being like that, I learned it from being among Caucasians."
    },
    "121": {
        "startTime": 699.231,
        "endTime": 711.73,
        "transcript": "Tua-i-llu mat'um nalliini wii taumi cali Nunapicuarmi arnassagaq au͡gna arnassagaurpallrunritliniuq taum nalliini.",
        "translation": "Then these days, that old lady there in Nunapitchuk apparently wasn't a very old lady at the time."
    },
    "122": {
        "startTime": 711.739,
        "endTime": 713.651,
        "transcript": "Ceńirrviktullruaqa.",
        "translation": "I would visit her."
    },
    "123": {
        "startTime": 713.66,
        "endTime": 718.804,
        "transcript": "Tauna tang iternaurtua arnaq eruriqcaaralria caminek.",
        "translation": "You see, I'd go in and that woman would be steadily washing her dishes."
    },
    "124": {
        "startTime": 718.819,
        "endTime": 724.13,
        "transcript": "Saaniini-ll' makut perriqcaarturnaura waten kaminiami qaingani.",
        "translation": "And she'd steadily wipe her kettles like this on top of her stove."
    },
    "125": {
        "startTime": 724.68,
        "endTime": 732.714,
        "transcript": "Tua-i-ll' itraqama taum arnam uutautengqelaan saarralanek, iciw' saarralanek uucitulriit yuut.",
        "translation": "Then when I went in, since that woman had burnt sugar cantly, you know how people make burnt sugar candy."
    },
    "126": {
        "startTime": 733.327,
        "endTime": 736.605,
        "transcript": "Wii tuar candy-rtaitellrulria tamaani.",
        "translation": "It seemed to me that there was no candy back then."
    },
    "127": {
        "startTime": 736.621,
        "endTime": 741.832,
        "transcript": "Taum arnam uutamek cikiqernauraanga, wiinga-ll' iqemkarluku.",
        "translation": "That woman would give me burnt sugar candy, and I'd put it in my mouth."
    },
    "128": {
        "startTime": 742.037,
        "endTime": 745.915,
        "transcript": "Saarralarninaqluni neqniqluni.",
        "translation": "It tasted sweet and delicious."
    },
    "129": {
        "startTime": 745.931,
        "endTime": 749.398,
        "transcript": "Tamana pitekluku tauna arnaq ullagyutullruaqa.",
        "translation": "That was the reason I'd want to go to that woman."
    },
    "130": {
        "startTime": 749.993,
        "endTime": 763.249,
        "transcript": "Taum caaqami pilaraanga arnam, \"Ilung',\" ilungaqliniamia, \"Ilung', wangtun piyaureskuvet aipangkuvet wangtun pilaqina.",
        "translation": "Sometimes, that would would say to me, \"Cuzz,\" because I was her cousin, \"Cuzz, if you became able like me and get married, do what I do."
    },
    "131": {
        "startTime": 763.261,
        "endTime": 766.594,
        "transcript": "\"Cangqelarniartuten atam.",
        "translation": "\"Watch, you will have things."
    },
    "132": {
        "startTime": 767.534,
        "endTime": 779.267,
        "transcript": "\"Caten eruyuunaki enevet iluani,\" tua-i nasaurlullraulua, \"uitaskuvki dust-am atam patularniarai.",
        "translation": "\"If you don't wash things in your house,\" I was a little girl, \"if you leave them, watch, dust will cover them."
    },
    "133": {
        "startTime": 779.282,
        "endTime": 784.716,
        "transcript": "\"Kiituani assiirucan qel'kenriran eggluku-llu.\"",
        "translation": "\"When it eventually gets bad, you don't keep it anymore and throw it away.\""
    },
    "134": {
        "startTime": 784.729,
        "endTime": 790.629,
        "transcript": "Tauna-llu nutarauyaaqluni tau͡gaam dust-am iqam patuluku.",
        "translation": "And that may be new, but dust and dirt covers it."
    },
    "135": {
        "startTime": 790.643,
        "endTime": 794.61,
        "transcript": "Tua-i-ll' aglumanairulluni piksuumirutnariluni-llu.",
        "translation": "Then it becomes undesirable and you wouldn't want it anymore."
    },
    "136": {
        "startTime": 794.613,
        "endTime": 797.002,
        "transcript": "Taum tang pitullrukiinga tuaten.",
        "translation": "You see, that's what she'd tell me."
    },
    "137": {
        "startTime": 797.015,
        "endTime": 805.86,
        "transcript": "Waten-llu piaqlua: ellii-gguq children's home, Moravian home, nani anglillruuq.",
        "translation": "She also told me this: she grew up somewhere, children's  home, Moravian home."
    },
    "138": {
        "startTime": 806.166,
        "endTime": 808.443,
        "transcript": "Tua-i-w' Kass'ani-am pillilria.",
        "translation": "It was probably among Caucasians."
    },
    "139": {
        "startTime": 808.514,
        "endTime": 813.892,
        "transcript": "Tamaaken-gguq nallunrillruuq how to clean up the house.",
        "translation": "She said she learned how to clean up the house from there."
    },
    "140": {
        "startTime": 815.02,
        "endTime": 821.809,
        "transcript": "Ala-i mat'um nalliini makut teenagers, they're smart.",
        "translation": "Oh my, these days these teenagers, they're smart."
    },
    "141": {
        "startTime": 822.343,
        "endTime": 829.287,
        "transcript": "They know how to clean up the house. They know how to do everything.",
        "translation": "They know how to clean up the house. They know how to do everything."
    },
    "142": {
        "startTime": 829.289,
        "endTime": 834.556,
        "transcript": "But they just sit and watch TV all day, maybe.",
        "translation": "But they just sit and watch TV all day, maybe."
    },
    "143": {
        "startTime": 834.675,
        "endTime": 839.73,
        "transcript": "Lazy, never do anything.",
        "translation": "Lazy, never do anything."
    },
    "144": {
        "startTime": 841.463,
        "endTime": 844.341,
        "transcript": "Tua-i, tua-i tamaa-i.",
        "translation": "There you have it."
    },
    "145": {
        "startTime": 844.344,
        "endTime": 849.511,
        "transcript": "Arnam taum arnaurrluni arnassagaam alerqualallra...",
        "translation": "That woman who became and old woman's instruction..."
    },
    "146": {
        "startTime": 850.472,
        "endTime": 852.672,
        "transcript": "Arenqiapaa. Ila-i.",
        "translation": "Oh no. Oh my goodness."
    },
    "147": {
        "startTime": 853.275,
        "endTime": 854.075,
        "transcript": "Canrituq.",
        "translation": "It's okay."
    },
    "148": {
        "startTime": 855.023,
        "endTime": 855.745,
        "transcript": "Tua-i?",
        "translation": "Ready?"
    },
    "149": {
        "startTime": 855.794,
        "endTime": 861.794,
        "transcript": "Waten pilaraanga: \"Ilung', iliini atam uingniartuten.\"",
        "translation": "She'd say this to me: \"Cuzz, watch, someday you'll get a husband.\""
    },
    "150": {
        "startTime": 862.248,
        "endTime": 865.271,
        "transcript": "Uingelleq, have husband.",
        "translation": "Uingelleq, have [a] husband."
    },
    "151": {
        "startTime": 865.703,
        "endTime": 868.147,
        "transcript": "\"Tuaten atam piniartuten.",
        "translation": "\"Watch, you will do that."
    },
    "152": {
        "startTime": 868.156,
        "endTime": 874.889,
        "transcript": "\"Tua-i-llu tuateun pikuvet eruyuilkuvki caten cangqerrngaituten.",
        "translation": "\"Then when you do that, if you don't wash your things, you won't have anything."
    },
    "153": {
        "startTime": 874.906,
        "endTime": 882.629,
        "transcript": "\"Uin-llu atam picupiaryaaqniartuq, arrsauniartuten atam.\"",
        "translation": "\"And watch, your husband may be a very good hunter, watch, you will be destitute.\""
    },
    "154": {
        "startTime": 883.106,
        "endTime": 885.195,
        "transcript": "Tuaten pilallruanga.",
        "translation": "That's what she'd tell me."
    },
    "155": {
        "startTime": 885.203,
        "endTime": 896.67,
        "transcript": "Cunaw' tang enem iluani cat take care-arnarqellinilriit, iciw' tua-i auluknaqluteng.",
        "translation": "It turned out, you see, that things need to be taken care of in the house, you know, need to be taken care of."
    },
    "156": {
        "startTime": 898.272,
        "endTime": 907.139,
        "transcript": "Tua-i mat'um naliini wii tua-i tamaani elisngariyukelqa Cakayiinkuni uitaqtaaralqa.",
        "translation": "These days, I thought I'd become knowledge about that back when I would stay with Cakayak and family."
    },
    "157": {
        "startTime": 908.111,
        "endTime": 916.678,
        "transcript": "Elitnaulallruyaaqellrianga-w' tua-i tuar tang aren wii ikgelan elitnaulqa elitelqa pitailnguq.",
        "translation": "I had gone to school, but it seems, I mean, since I didn't go to school for long, I didn't learn much."
    },
    "158": {
        "startTime": 916.933,
        "endTime": 921.966,
        "transcript": "Tua-i-ll' mat'um nalliini waten cali qanlartut:",
        "translation": "Then these days, they also say this:"
    },
    "159": {
        "startTime": 922.256,
        "endTime": 930.811,
        "transcript": "\"Arnanek-gguq irnialek arnaq, atam-gguq taum arnam aanani tangvagniaraa enem iluani.",
        "translation": "\"A woman with female children, watch, that woman will watch her mother in the house."
    },
    "160": {
        "startTime": 931.049,
        "endTime": 939.038,
        "transcript": "\"Tua-i-llu-gguq calillra callra arnam cali taum irniaran ayuqeliyugngaluku.\"",
        "translation": "\"Then her work and what she does, that woman's child can copy her.\""
    },
    "161": {
        "startTime": 940.696,
        "endTime": 942.874,
        "transcript": "Piciugut makut.",
        "translation": "These [words] are true."
    },
    "162": {
        "startTime": 943.039,
        "endTime": 948.961,
        "transcript": "Wiinga-ll' waniw' nine-aanek irniangqertua, five girls, four boys.",
        "translation": "And now, I have nine children, five girls, four boys."
    },
    "163": {
        "startTime": 949.118,
        "endTime": 958.14,
        "transcript": "Ukut-llu five girls ayuqenritut tamarmeng. Iciw' ayuqenritut.",
        "translation": "And these five girls are all different. You know, they're different."
    },
    "164": {
        "startTime": 961.234,
        "endTime": 965.045,
        "transcript": "Tamalkuita-ll' taukut wii kenkepiarluki.",
        "translation": "And I love them all very much."
    },
    "165": {
        "startTime": 965.18,
        "endTime": 970.902,
        "transcript": "Tua-i-ll' caliyaurcama cali mingeqsaurcama tua-i",
        "translation": "Then when I started making things and started sewing"
    },
    "166": {
        "startTime": 970.916,
        "endTime": 976.449,
        "transcript": "Ukut-ll' angliriluteng ukut yuungnaqengluteng paniinka.",
        "translation": "And my daughters grew up and started making their own living."
    },
    "167": {
        "startTime": 977.289,
        "endTime": 981.078,
        "transcript": "Caliurnaunka mingqurluki-ll'.",
        "translation": "I'd keep making them  things and sewing them things."
    },
    "168": {
        "startTime": 981.424,
        "endTime": 990.324,
        "transcript": "Iliini enaitnun it'lartua cailkama tauna im' mingqelqa. Umyuaqa tang pinaurtuq.",
        "translation": "I'd sometimes go in their houses, and what I sewed would be on the floor. You see, I'd be upset."
    },
    "169": {
        "startTime": 990.691,
        "endTime": 996.28,
        "transcript": "Cunawa-m' tua-i assircaarluku call' tauna uitaarkaq cailkamtelluku.",
        "translation": "It turned out that what was supposed to be kept well was on the floor."
    },
    "170": {
        "startTime": 996.293,
        "endTime": 1000.149,
        "transcript": "Iliinun panima iternaurtua neat.",
        "translation": "I'd go in one of daughters [and the house is] neat."
    },
    "171": {
        "startTime": 1001.385,
        "endTime": 1005.874,
        "transcript": "Aren, caliallrenka-ll' makut kenkumaluteng.",
        "translation": "Oh my, what I made would be treated with love."
    },
    "172": {
        "startTime": 1006.347,
        "endTime": 1020.436,
        "transcript": "Tua-i-ll' tuaten piama waniwa irniamni five girls, malruk, atrit aperngaitanka, wii tangerturallemni neat.",
        "translation": "Then when I did that, among the five girls of my children, two of them, I won't say their names, are neat from what I've seen."
    },
    "173": {
        "startTime": 1020.827,
        "endTime": 1024.072,
        "transcript": "Kass'at apqiitnek neat.",
        "translation": "Neat, as they say in English."
    },
    "174": {
        "startTime": 1024.646,
        "endTime": 1029.802,
        "transcript": "Assirtuk. Tamarmeng assiryaaqut.",
        "translation": "They're good. All of them are good."
    },
    "175": {
        "startTime": 1029.82,
        "endTime": 1038.943,
        "transcript": "Tua-i-ll' waten piunga: mingqaallrenka aturiallrenka taukuk care-aqapiarluki.",
        "translation": "Then I realized this: those two would take great care of the clothes I sewed."
    },
    "176": {
        "startTime": 1038.953,
        "endTime": 1047.764,
        "transcript": "Arcaqerluni-am aipaan care-aamiki eniinun itraqama tua-i tanglaamteki",
        "translation": "Since the other especially cares for them, when I go into her house because we see them"
    },
    "177": {
        "startTime": 1048.819,
        "endTime": 1061.995,
        "transcript": "Kiagmi caliallrenka mingqaat atkuut, piluguut, furs, fur clothes kiagmi tangerqayuitanka eniin iluani, nothing.",
        "translation": "In the summer, the things I made by sewing, parkas, fur boots, furs, fur clothes, I never see then in her house during the summer, nothing."
    },
    "178": {
        "startTime": 1062.279,
        "endTime": 1064.89,
        "transcript": "She put them away.",
        "translation": "She put[s] them away."
    },
    "179": {
        "startTime": 1065.825,
        "endTime": 1068.414,
        "transcript": "Iciw' put away-larai.",
        "translation": "You know, she puts them away."
    },
    "180": {
        "startTime": 1068.428,
        "endTime": 1077.783,
        "transcript": "Kass'ani nallunritua fur-at uitavingqertut pitalqellriamek enemek.",
        "translation": "I know that in the West, fur [clothes] have places, suitable spaces."
    },
    "181": {
        "startTime": 1077.789,
        "endTime": 1082.478,
        "transcript": "Kiircetevkenani, nengllirpek'nani, maybe meduim.",
        "translation": "It's not hot, it's not cold, maybe meduim."
    },
    "182": {
        "startTime": 1082.498,
        "endTime": 1084.998,
        "transcript": "Tua-i-ll' fur-ani assirluteng.",
        "translation": "Then their fur is good."
    },
    "183": {
        "startTime": 1085.001,
        "endTime": 1096.001,
        "transcript": "Atam cat wani makut skin-at agaurarqameng years and years aturviirutetuut uuluteng.",
        "translation": "Look, when these skin clothes hang for years and years, they're no longer suitable to wear [?from wearing out]."
    },
    "184": {
        "startTime": 1096.785,
        "endTime": 1101.152,
        "transcript": "Tegukumni-ll' una atkuk allegluni. Uuluni.",
        "translation": "And if I take this parka, it rips. [?It wears out]."
    },
    "185": {
        "startTime": 1101.509,
        "endTime": 1107.331,
        "transcript": "Tua-i-llu waniwa niicuilkemnek makuni TV-ni qalartua.",
        "translation": "Then now, I'm speaking about what I don't hear in these TV's."
    },
    "186": {
        "startTime": 1107.34,
        "endTime": 1112.729,
        "transcript": "Amlleq qalartelartuq avani imumi tamakunek.",
        "translation": "Many would speak of those long ago."
    },
    "187": {
        "startTime": 1112.738,
        "endTime": 1123.36,
        "transcript": "Mat'um nalliini arcaqalriaruuq tukuussiyaagata yuut Agayutem cikiutekngateng cat.",
        "translation": "It's important these days because people are too wealthy, since things are God's gifts."
    },
    "188": {
        "startTime": 1123.368,
        "endTime": 1127.346,
        "transcript": "Enem iluani cat Agayutem cikiutekai.",
        "translation": "Things in the house are God's gifts."
    },
    "189": {
        "startTime": 1127.365,
        "endTime": 1133.499,
        "transcript": "Arnam take care-ararkaugai assirluki.",
        "translation": "A woman must take good care of them."
    },
    "190": {
        "startTime": 1133.539,
        "endTime": 1138.261,
        "transcript": "Ilii angutem pituuq atam.",
        "translation": "You see, some men do [that]."
    },
    "191": {
        "startTime": 1138.276,
        "endTime": 1141.587,
        "transcript": "Wii waniw' nengaungqertua ayuqenrilngurnek.",
        "translation": "Now, I have different sons-in-law."
    },
    "192": {
        "startTime": 1141.741,
        "endTime": 1146.475,
        "transcript": "Iliin uinga nuliani ikayuayunqeggluku.",
        "translation": "Some of their husbands likes to help their wives."
    },
    "193": {
        "startTime": 1146.484,
        "endTime": 1150.873,
        "transcript": "Irnianka-w' tua-i tuaten ayuquten ilait.",
        "translation": "Some of my children are like that."
    },
    "194": {
        "startTime": 1150.887,
        "endTime": 1155.375,
        "transcript": "Iliin-llu uinga uitauratuluni.",
        "translation": "Some of their husbands is sedentary."
    },
    "195": {
        "startTime": 1155.388,
        "endTime": 1159.543,
        "transcript": "Arnii nallmikun kiiryugluni caliluni.",
        "translation": "His wife is hot and works around him."
    },
    "196": {
        "startTime": 1159.551,
        "endTime": 1163.907,
        "transcript": "Angutiin-llu ikayuyuunaku, angutnguami-wa.",
        "translation": "And her husband doesn't help her because he's a man."
    },
    "197": {
        "startTime": 1163.916,
        "endTime": 1172.383,
        "transcript": "Angutet qagaani caliarkaungameng outside work, arnaq-llu enem iluani inside work.",
        "translation": "It's because men are supposed to work out there, outside work, and woman in the house, inside work."
    },
    "198": {
        "startTime": 1172.511,
        "endTime": 1179.278,
        "transcript": "Tau͡gaam ayuqenrilata yuut ayuqenrilngurnek-am ukut paniinka aipangqelartut.",
        "translation": "But because people are different, my daughters have different kinds of spouses."
    },
    "199": {
        "startTime": 1179.412,
        "endTime": 1187.578,
        "transcript": "Ilait tang nuliat, tamakut-am wii assikpiaranka aipait makut aipateng care-aqait.",
        "translation": "Some of their wives, you see, I really like those spouses who take care of their spouses."
    },
    "200": {
        "startTime": 1187.593,
        "endTime": 1189.681,
        "transcript": "Angli-ll' taumi assirpaa.",
        "translation": "My goodness, that person's so good."
    },
    "201": {
        "startTime": 1190.138,
        "endTime": 1192.215,
        "transcript": "Pituaput.",
        "translation": "We tell them [that]."
    },
    "202": {
        "startTime": 1192.76,
        "endTime": 1194.882,
        "transcript": "Keneknaqluteng.",
        "translation": "They are lovable."
    },
    "203": {
        "startTime": 1195.109,
        "endTime": 1201.009,
        "transcript": "Uitauryulriit waten, qaill' atak' apqerlaku?",
        "translation": "Those who are sedentary like this, how should I say it?"
    },
    "204": {
        "startTime": 1201.424,
        "endTime": 1204.924,
        "transcript": "Mat'um nalliini-llam qanlartut, \"Weird.\"",
        "translation": "These days, they say, \"Weird.\""
    },
    "205": {
        "startTime": 1204.94,
        "endTime": 1208.473,
        "transcript": "Weird-aq una wii taringyuitaqa.",
        "translation": "I don't understand this word \"weird.\""
    },
    "206": {
        "startTime": 1208.481,
        "endTime": 1212.292,
        "transcript": "Tuar-llu tang tauna tuaten uitauralria weird-alria.",
        "translation": "It seems that one who's sedentary like that is weird."
    },
    "207": {
        "startTime": 1214.591,
        "endTime": 1222.425,
        "transcript": "Wiinga atam qalartaqama temcinarqellrianek avuaqluku pituunga.",
        "translation": "You see, when I speak, I add in some silly things."
    },
    "208": {
        "startTime": 1222.472,
        "endTime": 1228.183,
        "transcript": "Tua-i man'a maa-i arcaqerluku qanruteksullruaqa.",
        "translation": "I especially wanted to talk about this."
    },
    "209": {
        "startTime": 1228.192,
        "endTime": 1243.159,
        "transcript": "Makut teenager-aat mat'um nalliini catussiyaanritellrat I sorry for them.",
        "translation": "How teenagers these days don't really do anything, I [am] sorry for them."
    },
    "210": {
        "startTime": 1244.254,
        "endTime": 1252.521,
        "transcript": "Aanait-llu caqtarturnaurtut, pania-wa un' inarrluni naaqillria.",
        "translation": "And their mothers would keep working, while her daughter here lays down and reads."
    },
    "211": {
        "startTime": 1252.86,
        "endTime": 1257.616,
        "transcript": "Tua-i-w' puqiameng pillilriit kalikanek.",
        "translation": "It's probably because they're fluent [enough to read] books."
    },
    "212": {
        "startTime": 1257.624,
        "endTime": 1264.546,
        "transcript": "Ilii-ll' apqiitnek video, teng teng teng teng teng.",
        "translation": "And some what they call video [games], ding ding ding ding ding."
    },
    "213": {
        "startTime": 1265.202,
        "endTime": 1277.08,
        "transcript": "Aqumluni couple hours calinami nangerrluni aanani ikayurluku wall'u atani.",
        "translation": "[S]he sits down for a couople hours when they should work, standing up and helping their mother or father."
    },
    "214": {
        "startTime": 1279.121,
        "endTime": 1282.21,
        "transcript": "Tua-i makunek qalartua.",
        "translation": "I'm speaking of these things."
    },
    "215": {
        "startTime": 1285.048,
        "endTime": 1297.193,
        "transcript": "Ilakelaatgu-llu Agayun, Agayutem cikiuta enem iluani take care-arnarqelliniut assircaarluki.",
        "translation": "And because they're with God, we must take good care of God's gifts in the house."
    },
    "216": {
        "startTime": 1299.366,
        "endTime": 1313.744,
        "transcript": "Tamaa-i tamana arcaqerluku imku'rqa, qanruteksullruaqa caliarkaq amllepiassiyaagan mat'um nalliini enem iluani.",
        "translation": "That's what I especially wanted to, you know, talk about because there's way too much work to be done in a house these days."
    },
    "217": {
        "startTime": 1314.135,
        "endTime": 1320.813,
        "transcript": "Arenqiatuq nerlaamta-llu taqnaurtukut tang estuuluq pengilun' erurarkat.",
        "translation": "It's unfortunate because we'd eat, and when we're done, you see, the table would have a mountain of dishes."
    },
    "218": {
        "startTime": 1320.825,
        "endTime": 1326.092,
        "transcript": "Wall'u qulqitet ingkut erurarkarugaat.",
        "translation": "Or in the shelves over there, so many dishes to wash."
    },
    "219": {
        "startTime": 1327.111,
        "endTime": 1331.7,
        "transcript": "Tua-i-ll' aanaq una caqtarturluni.",
        "translation": "Then this mother keeps working."
    }
};